import { render } from "./VTable.vue?vue&type=template&id=8b37ad14&scoped=true"
import script from "./VTable.vue?vue&type=script&lang=js"
export * from "./VTable.vue?vue&type=script&lang=js"

import "./VTable.vue?vue&type=style&index=0&id=8b37ad14&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b37ad14"]])

export default __exports__